// import { }              from "../actions/types";
// import isEmpty from '../validation/is-empty';

import { SET_DATA_TABLE_ATTR } from '../actions/types'

const initialState = {
  tables: {},
}

export default function (state = initialState, action) {
  const { payload, type } = action
  switch (type) {
    case SET_DATA_TABLE_ATTR:
      return {
        ...state,
        tables: payload,
      }
    default:
      return state
  }
}
